// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"blog","40":"debug","75":"mc","472":"settings","792":"main"}[chunkId] + "-" + {"19":"752b9","40":"82945","75":"3d5ed","472":"2aea7","792":"55018"}[chunkId] + ".js";
};